import React, { useEffect, useState } from 'react';
import MenuDataCommon from './MenuItems/CommonMenuItems/menuItems.json';
import AldiMenuData from './MenuItems/AldiMenuItems/AldiMenuItems.json';
import AdminMenuData from './MenuItems/AdminMenuItems/AdminMenuItems.json';
import Domains from '../../global/constants/domain.ts';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Collapse, Drawer, List, IconButton, ListItemButton, ListItemText, Menu, MenuItem, useMediaQuery } from '@mui/material';
import { ArrowRight, ArrowDropDown, ExpandLess, ExpandMore } from '@mui/icons-material';
import { MenuIcon } from 'lucide-react';


interface MenuItemType {
  label: string;
  id: string;
  path?: string;
  subMenu?: MenuItemType[];
  roleIds?: number[];
  newTab?: boolean;
}

function Header_Menu({ userRole }: { userRole: number | null }) {
  const [menuData, setMenuData] = useState<MenuItemType[]>([]);
  const [anchorEls, setAnchorEls] = useState<{ [key: string]: HTMLElement | null }>({});
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileExpand, setMobileExpand] = useState<{ [key: string]: boolean }>({});
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:768px)");

  useEffect(() => {
    setMenuData(MenuDataCommon);
  }, []);


  const toggleMobileExpand = (id: string) => {
    setMobileExpand((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const handleOpen = (event: React.MouseEvent<HTMLElement>, id: string) => {
    event.stopPropagation();
    setAnchorEls((prev) => ({ ...prev, [id]: event.currentTarget }));
  };

  const handleClose = (id: string) => {
    setAnchorEls((prev) => ({ ...prev, [id]: null }));
  };

  const closeAllMenus = () => {
    setAnchorEls({});
  };

  const handleNavigation = (item: MenuItemType) => {
    if (!item.path) return;
    if (item.newTab) {
      window.open(item.path, "_blank", "noopener,noreferrer");
    } else {
      navigate(item.path);
    }
  };

  const filterMenuByRole: any = (menu: MenuItemType[], role: number | null) =>
    menu
      .filter((item) => !item.roleIds || (role !== null && item.roleIds.includes(role)))
      .map((item: any) => ({
        ...item,
        subMenu: item.subMenu ? filterMenuByRole(item.subMenu, role) : undefined,
      }));


  const desktopMenuItems = filterMenuByRole(menuData, userRole);

  const renderMobileMenu = (items: MenuItemType[], parentId = "") =>
    items.map((item) => {
      const id = parentId + item.id;
      const hasSub = item.subMenu && item.subMenu.length > 0;

      return (
        <React.Fragment key={id}>
          <ListItemButton
            onClick={() => {
              if (hasSub) {
                toggleMobileExpand(id);
              } else {
                handleNavigation(item);
                setMobileOpen(false);
              }
            }}
          >
            <ListItemText primary={item.label} />
            {hasSub ? mobileExpand[id] ? <ExpandLess /> : <ExpandMore /> : null}
          </ListItemButton>

          {hasSub && (
            <Collapse in={mobileExpand[id]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pl: 3 }}>
                {renderMobileMenu(item.subMenu!, id)}
              </List>
            </Collapse>
          )}
        </React.Fragment>
      );
    });

  const renderSubMenu = (subItems: MenuItemType[], parentId: string) =>
    subItems.map((subItem) => {
      const hasNested = subItem.subMenu && subItem.subMenu.length > 0;
      const id = `${parentId}-${subItem.id}`;

      return (
        <React.Fragment key={id}>
          <MenuItem
            component={!hasNested && subItem.path ? Link : "li"}
            to={subItem.path}
            onClick={(e) => {
              e.stopPropagation();
              if (hasNested) {
                handleOpen(e, id);
              } else {
                closeAllMenus();
                // if (subItem.path) navigate(subItem.path);
                // handleNavigation(subItem);
              }
            }}
          >
            {subItem.label}
            {hasNested && <ArrowRight fontSize="small" style={{ marginLeft: 'auto' }} />}
          </MenuItem>

          {hasNested && (
            <Menu
              anchorEl={anchorEls[id]}
              open={Boolean(anchorEls[id])}
              onClose={() => handleClose(id)}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
              {renderSubMenu(subItem.subMenu!, id)}
            </Menu>
          )}
        </React.Fragment>
      );
    });

  const renderMenu = (item: MenuItemType) => {
    const hasSubMenu = item.subMenu && item.subMenu.length > 0;
    const id = item.id;

    return (
      <div key={id} className='extra'>
        <Button
          component={!hasSubMenu && item.path ? Link : "button"}
          to={item?.path}
          id={`button-${id}`}
          aria-controls={hasSubMenu ? `menu-${id}` : undefined}
          aria-haspopup="true"
          className="text-light"
          // onClick={(e) =>
          //   hasSubMenu
          //     ? handleOpen(e, id)
          //     : item.path
          //     ? navigate(item.path)
          //     : null
          // }
          onClick={(e) => {
            if (hasSubMenu) {
              handleOpen(e, id);
            } else {
              // handleNavigation(item);
            }
          }}
          variant="text"
          sx={{ mx: 1, textTransform: 'none', fontWeight: 600 }}
        >
          {item.label}
          {hasSubMenu && <ArrowDropDown />}
        </Button>

        {hasSubMenu && (
          <Menu
            id={`menu-${id}`}
            anchorEl={anchorEls[id]}
            open={Boolean(anchorEls[id])}
            onClose={() => handleClose(id)}
          >
            {renderSubMenu(item.subMenu!, id)}
          </Menu>
        )}
      </div>
    );
  };
  // const filterMenuByRole = (menu: any[], role: any) => {
  //   return menu
  //     .filter((item) => item?.roleIds?.includes(role)) // filter current level
  //     .map((item) => ({
  //       ...item,
  //       subMenu: item.subMenu ? filterMenuByRole(item.subMenu, role) : undefined, // filter children
  //     }));
  // };

  return (
    <div className="d-flex align-items-center">
      {isMobile ? (
        <>
          <IconButton onClick={() => setMobileOpen(true)} color="inherit">
            <MenuIcon />
          </IconButton>

          <Drawer anchor="left" open={mobileOpen} onClose={() => setMobileOpen(false)}>
            <List sx={{ width: 260, mt: 2 }}>
              {renderMobileMenu(desktopMenuItems)}
            </List>
          </Drawer>
        </>
      ) : (
        // DESKTOP MENU
        desktopMenuItems.map((item: any) => renderMenu(item))
      )}
    </div>
  );
}

export default Header_Menu;
